/**
 * Het merkteken voor een organisatie zonder eigen logo of icoon: een gekleurd
 * vierkant met één of twee letters. Wordt op drie plekken gebruikt — de
 * browsertab (favicon), de menubalk/het inlogscherm, en het midden van de
 * QR-code — en moet er dus overal exact hetzelfde uitzien. Vandaar één
 * gedeelde tekenfunctie in plaats van dat elke plek zijn eigen versie bouwt.
 */

/**
 * Een of twee letters uit een naam. "Kiwanis Venray" -> "KV", "Kiwanis" -> "K".
 * Bedoeld voor een organisatienaam van meerdere woorden, zodat "Kiwanis Venray"
 * en "Kiwanis Schieëepersland" niet allebei als kaal "K" verschijnen.
 */
export function initialenVan(naam) {
    const woorden = (naam || '').trim().split(/\s+/).filter(Boolean);

    if (woorden.length === 0) return '';
    if (woorden.length === 1) return woorden[0].charAt(0).toUpperCase();

    return (woorden[0].charAt(0) + woorden[1].charAt(0)).toUpperCase();
}

/**
 * Tekent het merkteken op canvas en geeft het terug als PNG data-URI, zodat
 * het zonder serverbestand als favicon of als QR-icoon gebruikt kan worden.
 * Canvas laat de hoeken vanzelf transparant — er wordt alleen het afgeronde
 * vierkant getekend, geen volledig vierkant met een witte achtergrond erachter.
 */
export function merktekenDataUri(letters, achtergrond, tekstkleur, grootte = 128) {
    const canvas = document.createElement('canvas');
    canvas.width = grootte;
    canvas.height = grootte;

    const ctx = canvas.getContext('2d');
    const straal = grootte * 0.22;

    ctx.beginPath();
    if (typeof ctx.roundRect === 'function') {
        ctx.roundRect(0, 0, grootte, grootte, straal);
    } else {
        // Safari vóór 16.4 kent roundRect niet; dan maar rechte hoeken — beter een
        // vierkant merkteken dan helemaal geen.
        ctx.rect(0, 0, grootte, grootte);
    }
    ctx.fillStyle = achtergrond;
    ctx.fill();

    ctx.fillStyle = tekstkleur;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = `800 ${grootte * (letters.length > 1 ? 0.42 : 0.54)}px -apple-system, 'Segoe UI', system-ui, sans-serif`;
    ctx.fillText(letters, grootte / 2, grootte / 2 + grootte * 0.03);

    return canvas.toDataURL('image/png');
}
